import type { ReactElement } from 'react';
import React from 'react';
import Breadcrumb from 'atom-components/breadcrumb-lite';
import { MarkingPath } from 'pages/marking/routes';

export default function Breadcrumbs(): ReactElement {
  return (
    <Breadcrumb>
      <Breadcrumb.Item href={MarkingPath.MarkerDashboard}>Marking</Breadcrumb.Item>
      <Breadcrumb.Item active>Mark Response</Breadcrumb.Item>
    </Breadcrumb>
  );
}
